import { createSlice } from '@reduxjs/toolkit';
import add from 'lodash/add';
import set from 'lodash/set';

const initialState = {
    totalVisits: null,
    isVisitModalOpen: false
};

const visitModalSlice = createSlice({
    name: 'visitModal',
    initialState,
    reducers: {
        openModal(state, action) {
            state.isVisitModalOpen = true;
        },
        closeModal(state) {
            state.isVisitModalOpen = false;
        },
        setTotalVisits(state, action) {
            state.totalVisits = action.payload;
        },
        addVisits(state, action) {
            state.totalVisits += action.payload;
        },
        deductVisits(state, action) {
            state.totalVisits -= action.payload;
        },

    },
});

export const { openModal, closeModal, setTotalVisits, addVisits, deductVisits } = visitModalSlice.actions;

export default visitModalSlice.reducer;
